import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=9a8107b8&scoped=true&v-if=getCurrentProjectPlan%20%26%26%20getPlanFeatures&"
import script from "./settings.vue?vue&type=script&lang=js&"
export * from "./settings.vue?vue&type=script&lang=js&"
import style0 from "./settings.vue?vue&type=style&index=0&id=9a8107b8&scoped=true&lang=css&"
import style1 from "./settings.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8107b8",
  null
  
)

export default component.exports